import { render, staticRenderFns } from "./PopupAddProduct.vue?vue&type=template&id=4f542817&"
import script from "./PopupAddProduct.vue?vue&type=script&lang=js&"
export * from "./PopupAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddProduct.vue?vue&type=style&index=0&id=4f542817&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports